<template>
    <div class="container">
      <h1>Calendário de {{ currentYear }}</h1>
      <p class="description">Os domingos e feriados nacionais estão destacados em vermelho.</p>
  
      <div class="calendar-container">
        <div v-for="month in months" :key="month.name" class="month">
          <h2>{{ month.name }}</h2>
          <table>
            <thead>
              <tr>
                <th v-for="day in daysOfWeek" :key="day">{{ day }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="week in month.weeks" :key="week">
                <td
                  v-for="day in week"
                  :key="day.date"
                  :class="{ sunday: day.isSunday, holiday: day.isHoliday }"
                >
                  {{ day.date || "" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
  
      
    </div>
  </template>
  
  <script>
  export default {
    name: "FullYearCalendar",
    data() {
      return {
        currentYear: new Date().getFullYear(),
        daysOfWeek: ["D", "S", "T", "Q", "Q", "S", "S"],
        months: [],
        holidays: [
          "01-01", // Confraternização Universal
          "04-21", // Tiradentes
          "05-01", // Dia do Trabalho
          "09-07", // Independência do Brasil
          "10-12", // Nossa Senhora Aparecida
          "11-02", // Finados
          "11-15", // Proclamação da República
          "12-25", // Natal
        ]
      };
    },
    mounted() {
      this.generateCalendar();
    },
    methods: {
      generateCalendar() {
        const year = this.currentYear;
        const monthNames = [
          "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
          "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ];
  
        this.months = monthNames.map((name, monthIndex) => {
          let firstDay = new Date(year, monthIndex, 1).getDay();
          let daysInMonth = new Date(year, monthIndex + 1, 0).getDate();
          let weeks = [];
          let week = new Array(firstDay).fill({ date: "" });
  
          for (let day = 1; day <= daysInMonth; day++) {
            let dateStr = `${(monthIndex + 1).toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
            let isSunday = (week.length % 7 === 0);
            let isHoliday = this.holidays.includes(dateStr);
  
            week.push({ date: day, isSunday, isHoliday });
  
            if (week.length === 7) {
              weeks.push(week);
              week = [];
            }
          }
          if (week.length) weeks.push(week);
  
          return { name, weeks };
        });
      },
      printCalendar() {
        window.print();
      }
    }
  };
  </script>
  
  <style scoped>
  .container {
    max-width: 900px;
    margin: auto;
    padding: 20px;
    text-align: center;
    font-family: "Arial", sans-serif;
  }
  
  h1 {
    font-size: 24px;
    margin-bottom: 10px;
  }
  
  .description {
    font-size: 16px;
    color: #555;
    margin-bottom: 20px;
  }
  
  .calendar-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
  }
  
  .month {
    width: 280px;
    background: #f8f9fa;
    padding: 15px;
    border-radius: 8px;
    text-align: center;
  }
  
  h2 {
    font-size: 18px;
    color: #007bff;
  }
  
  table {
    width: 100%;
    border-collapse: collapse;
  }
  
  th, td {
    padding: 6px;
    text-align: center;
    border: 1px solid #ccc;
  }
  
  .sunday {
    color: red;
  }
  
  .holiday {
    background: #ffdddd;
    font-weight: bold;
  }
  
  .actions {
    margin-top: 20px;
  }
  
  button {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 10px 20px;
    font-size: 18px;
    border-radius: 5px;
    cursor: pointer;
    transition: 0.3s;
  }
  
  button:hover {
    background-color: #0056b3;
  }
  </style>
  